<template>
  <SfModalPortal
    modal-id="mark-proposal-as-finalized-modal"
    :scrollable-content="true"
    size="s"
  >
    <template #title>{{
      I18n.t('reconciliation_proposal.pulse.mark_as_finalized')
    }}</template>
    <template #messages>
      <SfModalMessage
        v-dompurify-html="
          I18n.t('reconciliation_proposal.pulse.mark_as_finalized_hint.done', {
            item,
          })
        "
        :variant="messageTypes.info"
      />
      <SfModalMessage v-if="failed" variant="error">{{
        I18n.t('reconciliation_proposal.pulse.failed_to_mark_as_finalized')
      }}</SfModalMessage>
    </template>

    <template #body>
      <form class="sf-form sf-form-full sf-below-3">
        <SfInput
          v-model="message"
          data-testid="message-field"
          component-type="textarea"
          :label="
            I18n.t(
              'reconciliation_proposal.pulse.mark_as_finalized_message_label'
            )
          "
          :placeholder="
            I18n.t(
              'reconciliation_proposal.pulse.mark_as_finalized_message_placeholder'
            )
          "
        />
      </form>
    </template>
    <template #footer>
      <SfButtonDs variant="secondary" @click="close">
        {{ I18n.t('confirmation.cancel') }}
      </SfButtonDs>
      <SfButtonDs
        :disabled="submitting"
        variant="primary"
        data-testid="finalize-proposal"
        @click="save"
      >
        {{ I18n.t('reconciliation_proposal.pulse.mark_as_finalized') }}
      </SfButtonDs>
    </template>
  </SfModalPortal>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { SfInput } from '@app/shared/vue/components/sf-input'
import SFetch from '@app/utils/sfetch'
import {
  SfModalPortal,
  SfModalMessage,
} from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { messageTypes } from '@app/shared/vue/components/sf-modal/constants'

const I18n = useI18n()

interface Props {
  item: string
  endpoint: string
  redirectPath?: string
}

const props = withDefaults(defineProps<Props>(), {
  redirectPath: undefined,
})

const message = ref('')
const failed = ref(false)
const submitting = ref(false)

defineOptions({
  name: 'MarkProposalAsFinalizedModal',
})

const save = async () => {
  submitting.value = true
  try {
    await SFetch.json(props.endpoint, {
      method: 'PUT',
      body: {
        message: message.value,
      },
    })
    window.Turbolinks.visit(props.redirectPath || window.location.href)
  } catch {
    failed.value = true
  } finally {
    submitting.value = false
  }
}

const reset = () => {
  failed.value = false
}

const close = () => {
  window.modalCitizen.closeModalPortal()
  reset()
}
</script>
